import React from "react";

import "./IdwalError.css";

export interface IdwalErrorsProps {
    errorCode?: number;
    additionalInfo?: string;
}

export const IdwalError = (props: IdwalErrorsProps) => {
    const statusCode = props.errorCode;
    const additionaInfo = props.additionalInfo;

    const contact = (
        <span>
            Please{" "}
            <a
                className={"portal-link"}
                href="https://www.idwalmarine.com/contact-us"
                target="_blank"
            >
                contact us
            </a>
            .
        </span>
    );

    const getReportTitle = () => {
        if (statusCode === 401) {
            return "Access Restricted";
        }
        return `Error ${statusCode}`;
    };

    return (
        <div
            className="max-width-wrapper flex flex-column"
            data-testid="idwal-error"
        >
            <div className="flex flex-column space-between">
                <div className="flex-item">
                    <p className="report-title">{getReportTitle()}</p>
                    {statusCode === 400 && (
                        <p>
                            Bad Request: The server could not understand the
                            request. {contact}
                        </p>
                    )}
                    {statusCode === 401 && (
                        <p style={{ fontSize: "1.5rem" }}>
                            Your account does not currently have access.{" "}
                            {contact}
                        </p>
                    )}
                    {statusCode === 403 && (
                        <p>
                            Forbidden: Access to this resource is forbidden.{" "}
                            {contact}
                        </p>
                    )}
                    {statusCode === 404 && (
                        <p>
                            Not found: The requested resource could not be found
                            on the server. {contact}
                        </p>
                    )}
                    {statusCode === 500 && (
                        <p>
                            Internal Server Error: The server encountered an
                            error and could not complete your request. {contact}
                        </p>
                    )}
                </div>
                <div className="flex-item"></div>

                {additionaInfo ? (
                    <div className="flex-item">
                        <details>{additionaInfo}</details>
                    </div>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};
